import { SKILL_TYPES } from "utils/constants";

export const handleSkillTypeChange = (formProps, index, type) => {
  formProps.setFieldValue(`skills.${index}.type`, type);

  if (type === SKILL_TYPES.DEPARTMENT) {
    const currentSelection = formProps.values?.skills?.[index]?.departmentSelection;
    const currentExclude = formProps.values?.skills?.[index]?.departmentExclude;

    if (currentSelection === undefined) {
      formProps.setFieldValue(`skills.${index}.departmentSelection`, []);
    }
    if (currentExclude === undefined) {
      formProps.setFieldValue(`skills.${index}.departmentExclude`, false);
    }
    formProps.setFieldValue(`skills.${index}.value`, null);
  }
};
